module.exports = __webpack_public_path__ + "static/media/srushti_gadale.d94bffed.png";